export const serviceUserLabel = (user, fallback = "—") => user?.name || user?.email || fallback;
export const serviceRuleActive = (rule) => rule.is_active !== false;
export const serviceAmountSet = (value) => value !== null && value !== undefined && value !== "";
export const serviceAmountValid = (form) => {
  const { amount_min: min, amount_max: max } = form;
  return [min, max].every((value) => !serviceAmountSet(value) || (Number.isFinite(Number(value)) && Number(value) >= 0)) &&
    (!serviceAmountSet(min) || !serviceAmountSet(max) || Number(min) <= Number(max));
};
export const serviceAmountText = (rule, t, locale) => {
  const format = (value) => new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(Number(value));
  if (serviceAmountSet(rule.amount_min) && serviceAmountSet(rule.amount_max)) return `${format(rule.amount_min)} – ${format(rule.amount_max)}`;
  if (serviceAmountSet(rule.amount_min)) return `${t("From")} ${format(rule.amount_min)}`;
  if (serviceAmountSet(rule.amount_max)) return `${t("Up to")} ${format(rule.amount_max)}`;
  return t("Any amount");
};
export const serviceScopeText = (rule, departments, t) => rule.department_id
  ? departments.find((department) => Number(department.id) === Number(rule.department_id))?.name || `${t("Department")} #${rule.department_id}`
  : t("All departments");

// Coverage is informational; the server checks the complete policy atomically.
export function serviceApproverCoverage(sender, approvers, users) {
  if (sender.action !== "requires_approval" || !serviceRuleActive(sender)) return [];
  const min = serviceAmountSet(sender.amount_min) ? Number(sender.amount_min) : 0;
  const max = serviceAmountSet(sender.amount_max) ? Number(sender.amount_max) : Infinity;
  return approvers.filter((approver) => serviceRuleActive(approver) &&
    (!users || users.some((user) => Number(user.id) === Number(approver.approver_user_id) && user.can_approve === true && user.is_active !== false)) &&
    (!approver.requester_user_id || Number(approver.requester_user_id) === Number(sender.user_id)) &&
    (!approver.department_id || Number(approver.department_id) === Number(sender.department_id)) &&
    (!serviceAmountSet(approver.amount_min) || Number(approver.amount_min) <= min) &&
    (!serviceAmountSet(approver.amount_max) || Number(approver.amount_max) >= max));
}

export function servicePolicyPayload(policy, changes = {}) {
  return {
    revision: policy?.revision ?? 0,
    version: 2,
    default_action: policy?.default_action || "requires_approval",
    sender_rules: policy?.sender_rules || [],
    approver_rules: policy?.approver_rules || [],
    ...changes,
  };
}

export function servicePolicyError(error, t) {
  if (error.response?.status === 409) return t("Another person changed these settings. Close the editor and reload before saving again.");
  if (error.response?.data?.code === "APPROVER_COVERAGE_REQUIRED") return t("An approval-required rule needs an active approver covering its requester, departments and full amount range.");
  return error.response?.data?.error || error.message || t("Could not save the policy.");
}
